
import React from 'react';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'var(--ih-theme-bg-primary)' }}>
      <header className="text-white border-b h-16 flex items-center px-6 justify-between sticky top-0 z-50" style={{ backgroundColor: 'var(--ih-theme-bg-dark)', borderColor: 'var(--ih-theme-border-light)' }}>
        {/* Logo */}
        <div className="flex items-center gap-3">
          <img src="/assets/images/logo.png" alt="Logo" className="h-10 object-contain" />
        </div>

        {/* Center Tagline */}
        <div className="absolute left-1/2 -translate-x-1/2">
          <div className="px-6 py-2 rounded-lg shadow-lg" style={{ backgroundColor: 'var(--ih-theme-accent)' }}>
            <h1 className="text-sm font-bold tracking-wide whitespace-nowrap" style={{ fontFamily: 'var(--ih-font-family-heading)', color: 'var(--ih-theme-white)' }}>Lets Gamify Logistics</h1>
          </div>
        </div>

        {/* Right Profile */}

      </header>
      <main className="flex-1 flex flex-col md:flex-row p-6 gap-6 max-w-[1600px] mx-auto w-full">
        {children}
      </main>
    </div>
  );
};

export default Layout;
